import React, { useState } from 'react';

import { Box, Typography } from '@mui/material';
import Modal from 'components/ModalV2';
import Tooltip from 'components/Tooltip';
import Button from 'components/V2/Button';
import PropTypes from 'prop-types';
import CustomFieldFlowChart from 'views/V2/Integration/components/CustomFieldFlowChart/components/FlowChartCanvas';

import styles from './passCriteriaHeader.module.css';

import { ReactComponent as ArrowRightIcon } from 'asset/IconsPack/at_arrow-right-filled.svg';
import { ReactComponent as NewFeatureIcon } from 'asset/IconsPack/at_star-06-filled.svg';

function PassCriteriaHeader({ titleClassName, workflowConfig }) {
    const [showWhatsNewModal, setShowWhatsNewModal] = useState(false);

    return (
        <>
            <Box className={styles.passCriteriaHeader}>
                <Typography className={titleClassName}>Pass Criteria</Typography>
                <Tooltip
                    title={
                        <>
                            We've upgraded to V2 custom fields with workflow-driven mapping.{' '}
                            <a
                                href="https://info.authenticate.com/hubfs/STR_V1_V2_Migration_Guide%20(2).pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                See how to migrate
                            </a>
                        </>
                    }
                    arrow
                    placement="right"
                    classes={{
                        tooltip: styles.deprecatedTagTooltip,
                    }}
                >
                    <Box className={styles.passCriteriaTag}>
                        <Typography className={styles.passCriteriaTagText}>Deprecated</Typography>

                        <Button
                            intent="primary-outline"
                            size="sm"
                            onClick={() => setShowWhatsNewModal(true)}
                            className={styles.seeWhatsNewButton}
                            startIcon={<NewFeatureIcon className={styles.newFeatureIcon} />}
                            endIcon={<ArrowRightIcon className={styles.arrowRightIcon} />}
                        >
                            See what's new
                        </Button>
                    </Box>
                </Tooltip>
            </Box>
            <Modal
                open={showWhatsNewModal}
                onClose={() => setShowWhatsNewModal(false)}
                className={styles.whatsNewModalContainer}
            >
                <Box className={styles.whatsNewModalContent}>
                    <Typography className={styles.whatsNewModalHeading}>
                        Workflow‑Driven Custom Field Mapping
                    </Typography>
                    <CustomFieldFlowChart
                        previewControllerEnabled={false}
                        workflowConfig={workflowConfig}
                    />
                </Box>
            </Modal>
        </>
    );
}

PassCriteriaHeader.propTypes = {
    titleClassName: PropTypes.string,
    workflowConfig: PropTypes.object,
};

export default PassCriteriaHeader;
